<template>
  <div class="flex justify-around w-full pb-2"><slot></slot></div>
</template>

<script lang="ts" setup></script>
